import { useState, useEffect } from "react"
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import SalaAdmon from './SalaAdmon.jsx'
import SalaVideo from '../comun/SalaVideo.jsx'
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { getProyectos, } from '../componentes/api.js';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import EmergencyRecordingIcon from '@mui/icons-material/EmergencyRecording';

const SalaStreaming =(props)=>{
  const [proyectos, setProyectos] = useState([]);
  const [idProyecto, setIdProyecto] = useState('');
  const [pantalla, setPantalla] = useState(0);


  const cargarProyectos = async()=>{
    try {
      const response = await getProyectos()
      setProyectos(response.data)
            
    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al cargar los Combos", error])
    }
  }

  const handleChange = (event, value) => {
    event.preventDefault();
    setPantalla(value);
  };


  useEffect(()=>{
    cargarProyectos();
  },[])

  const mostrarPantalla =()=>{
    if(pantalla===0) 
      return(
        <SalaAdmon 
          idProyecto={idProyecto} 
          idUsuario={props.idUsuario}
          mostrarMsg={props.mostrarMsg}
        />)
    else if(pantalla===1) 
      return(
        <SalaVideo   
          idProyecto={idProyecto}
          idUsuario={props.idUsuario} 
          nbres={props.nbres} 
          mostrarMsg={props.mostrarMsg}
          tipoParticipante={props.tipoParticipante} 
          socket={props.socket} 
        />
      )
  }

  return(
    <div className="container-fluid card shadow mt-2">

      


      <div className="row">
        <Alert severity="success">
          <AlertTitle><strong>SALAS DE REUNION</strong></AlertTitle>
          Acá puede Administrar e Ingresar a las videoconferencias
        </Alert>
      </div>

      <div className="row">
        <Tabs value={pantalla} onChange={handleChange} aria-label="salas de reunión" >
          <Tab icon={<EmergencyRecordingIcon />} label="Administrar Salas" disabled={idProyecto!==''? false:true}/>
          <Tab icon={<VideoCallIcon />} label="Ingresar a Sala de Reunión" disabled={idProyecto!==''? false:true} />
        </Tabs>
      </div>

      <div className="row form-floating mb-3 mx-2 mt-3">
        <select
          type="text" 
          className="form-control" 
          name='idProyecto' 
          value={idProyecto} 
          onChange={(event) =>{setIdProyecto(event.target.value)}}
        >
          <option key='0' value='0'>Por favor seleccione un Proyecto...</option>
          {proyectos.map((reg) => {
            return (
              <option key={reg.Id} value={reg.Id} label={reg.Nbre}> {reg.Nbre} </option>
            );
          })}
        </select>
        <label htmlFor="idProyecto">Seleccione un Proyecto</label>
      </div>

      <div className="row">
        {mostrarPantalla()}
      </div>
    </div>
  )
}

export default SalaStreaming